var CommonJoin = (function () {

    var FLOW_URL = {
        TEST: '.flowtest.info',
        REAL: Often.isGlobal() ? '.morningmate.com' : '.flow.team',
    }

    return {

        //get
        getUserInfo: getUserInfo,
        getDefaultPlanId: getDefaultPlanId,

        //set
        changeInputErrorMsg: changeInputErrorMsg,
        setUserStepEvent: setUserStepEvent,
        setTeamStepEvent: setTeamStepEvent,
        setBasicStepEvent: setBasicStepEvent,
        setBackEvent: setBackEvent,
        setGtmCollect: setGtmCollect,
        savePlanId: savePlanId,

        //action
        goLoginAfterJoin: goLoginAfterJoin,
        moveUserStep: moveUserStep,

        //event
        focusoutJoinInput: focusoutJoinInput,
        changeFirstStepButton: changeFirstStepButton,
        moveSecondStepButton: moveSecondStepButton,
        moveFinalStepButton: moveFinalStepButton,
        clickConfirmCheck: clickConfirmCheck,
        keyupJoinInput: keyupJoinInput,
        mousedownViewButton: mousedownViewButton,
        mouseupViewButton: mouseupViewButton,
        mousedownViewToggleButton: mousedownViewToggleButton,
        changeTeamSector: changeTeamSector,
        registerSubDomain: registerSubDomain,
        useSpaceBarToCheck: useSpaceBarToCheck,

        getPartnerInfo: getPartnerInfo,
    }

    function setBackEvent() {
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
            if ($("#basicStep").is(":visible")) {
                history.back();
            } else {
                location.reload();
            }
        }
    }

    function setBasicStepEvent() {
        const $basicStep = $("#basicStep");
        $basicStep.find("#createNewCompany").off("click").on("click", function () {
            moveUserStep();
        });
        $basicStep.find("#startGuest").off("click").on("click", GuestStep.openGuestStep);
        $basicStep.find("#requestConsultButton").off("click").on("click", openConsultPage);
        $basicStep.find("#joinCompany").off("click").on("click", CompanyJoin.openLayer);
    }

    function getDefaultPlanId() {
        if(Often.isGlobal()){
            if(isLegacyPlan()){
                const suffix = {
                    KR: 'UK_A',
                    GB: 'UK_A',
                    JP: 'JP_A',
                    VI: 'VI_A',
                    KH: 'KH_A'
                }[window._CLIENT_REGION] || 'ETC_A';
                return "MORNING_BUSINESS_" + suffix;
            } else {
                const euroCountries = new Set([
                    "AT", "BE", "HR", "CY", "EE", "FI", "FR", "DE", "GR",
                    "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PT", "SK",
                    "SI", "ES"
                ]);

                const regionToSuffixMap = new Map([
                    ['GB', 'UK_A'],
                    ['US', 'US_A']
                ]);

                const suffix = regionToSuffixMap.get(window._CLIENT_REGION)
                    || (euroCountries.has(window._CLIENT_REGION) ? 'EU_A' : 'ETC_A');

                return "MORNING_ADVANCED_" + suffix;
            }
        } else {
            return "BUSINESS_PRO_KR_A";
        }

        // 관련 기능키: MORNINGMATE_LEGACY_PLAN
        function isLegacyPlan() {
            const legacyRegions = ['JP', 'VN', 'KH'];
            return legacyRegions.includes(window._CLIENT_REGION);
        }

    }

    function savePlanId() {
        LocalUtil.setLocal("JOIN_PLAN_ID", getDefaultPlanId());
    }

    function moveUserStep(isSubDomJoin) {
        $("#basicStep").fadeOut(0);
        $("#companyJoinLayer").fadeOut(0);

        const $userStep = $("#userStep");
        $userStep.find("#noUpgradeLayer").css("display", (isSubDomJoin ? "none" : "block"));
        $userStep.find("#teamStepButton").css("display", (isSubDomJoin ? "none" : "inline-block"));
        $userStep.find("#subDomJoinButtonArea").css("display", (isSubDomJoin ? "flex" : "none"));
        //스크롤 내려가는 이슈 있어서 top으로 고정
        $(document).scrollTop(0);

        if (isSubDomJoin) {
            GoogleTagManager.collect({event: 'joinup2'});
            $userStep.find("#userStepTitle").text(i18next.t(main.login.createCompany)); // 회사 계정 만들기
            $userStep.find("#userStepDesc").text(i18next.t(main.login.createCompanyDesc)); // 회사 관리자의 가입 승인 이후부터 사용이 가능합니다.
        } else {
            if(Often.isGlobal()) GoogleTagManager.collect({event: 'signup2'});
            else GoogleTagManager.collect({event: "ga4_signup2"});
            savePlanId();
        }
        $userStep.fadeIn(200);
    }

    function openConsultPage() {
        OpenUtil.openWindow("/consult.act", "_blank");
    }

    function setUserStepEvent() {
        var $userStep = $("#userStep");
        $userStep.find("input").on("keyup", keyupJoinInput);
        $userStep.find("select").on("change", clickOnJobTitle);
        if (Often.isMobile() || Often.isTablet()) {
            $userStep.find(".js-view-button").on("mousedown", mousedownViewToggleButton);
        } else {
            $userStep.find(".js-view-button").on("mousedown", mousedownViewButton).on("mouseup", mouseupViewButton);
        }
        $userStep.find("#joinUserEmail").on("focusout", focusoutJoinInput);
        $userStep.find("#joinConfirmCheck").on("click", clickConfirmCheck);
        $userStep.find("#ageLimitConfirmCheck").on("click", clickConfirmCheck);
        $userStep.find(".js-confirm-check").on("keydown", useSpaceBarToCheck);
        $userStep.find("#guestStepButton")
            .on("click", changeFirstStepButton)
            .on("keyup", (e) => {
                if (KeyCheck.isKey(e, "ENTER")) changeFirstStepButton(e);
            });
        $userStep.find("#teamStepButton")
            .on("click", function (e) {
                moveSecondStepButton(e, BusinessJoin.openTeamStep);
            })
            .on("keyup", (e) => {
                if (KeyCheck.isKey(e, "ENTER")) moveSecondStepButton(e, BusinessJoin.openTeamStep);
            });

        $userStep.find("#movePrevButton").off("click").on("click", function () {
            window.SUB_DOM = '';
            CompanyJoin.openLayer();
        });
        $userStep.find("#moveNextButton").off("click").on("click", registerSubDomain);

        if (Often.isFunc("js-signup-age-agree"))
            $(".js-signup-age-agree")
    }

    function setTeamStepEvent() {
        const $teamStep = $('#teamStep')
        $teamStep.find('input').on('keyup focusout', focusoutJoinInput)
    }

    function useSpaceBarToCheck(e) {
        if (!KeyCheck.isKey(e, "SPACE_BAR")) return;
        e.preventDefault();
        const $eTarget = $(e.target);
        const checkBoxId = $eTarget.attr("for");
        $(`#${checkBoxId}`).trigger("click");
    }

    // firstStep : userStep, guestStep
    function changeFirstStepButton(e) {
        var $userStep = $("#userStep");
        var $guestStep = $("#guestStep");
        var $teamStep = $("#teamStep");
        var $eTarget = $(e.target);
        if ($eTarget.is("#userStepButton")) {
            clearPrevPageData($guestStep.find("input"));
            $guestStep.fadeOut(0);
            moveUserStep(false);
        } else if ($eTarget.is("#guestStepButton")) {
            clearPrevPageData($userStep.find("input"));
            clearPrevPageData($teamStep.find("input"));
            GuestStep.openGuestStep();
        }
    }

    // secondStep :teamStep, guestFinalStep
    function moveSecondStepButton(e, callback) {
        var isStop;
        var $eTarget = $(e.target);
        var $mainStep = $eTarget.findUp(".js-main-step");
        var isGuest = $mainStep.is("#guestStep");
        var joinFormValue = $mainStep.find(".js-join-email").val();
        if (isInputsError($mainStep)) isStop = true;
        if (isJobTitleSelected($mainStep)) isStop = true;
        if (!isCheckConfirm($eTarget)) isStop = true;
        if (isStop) return;
        var isSubDomJoin = !Often.isEmpty(window.SUB_DOM);
        var isNewCompanyJoin = !isGuest && !isSubDomJoin;
        if (isNewCompanyJoin) {
            if(!Often.isGlobal())GoogleTagManager.collect({event: "ga4_signup3"});
            setGtmCollect( Often.isGlobal()? "signup3" : "signUp0");
        } else if(Often.isGlobal() || isSubDomJoin){
            GoogleTagManager.collect({event: 'joinup3'});
        }
        $("body").css("overflow-y", "hidden");
        EmailAuth.sendToServer(joinFormValue, joinFormValue, "E", isGuest, function () {
            $("body").css("overflow-y", "auto");
            (typeof callback === "function") && callback()
        });
    }

    function isCheckConfirm($eTarget) {
        var isAllChecked = true;
        var $confirmCheck = $eTarget.parents('form').find(".js-confirm-input-require");
        $confirmCheck.each((i, e) => {
            var isChecked = $(e).hasClass("checked");
            if (!isChecked) {
                var $errorText = $(e).findUp(".js-join-check").find(".js-error-text");
                $errorText.css("display", "block");
            }
            isAllChecked &= isChecked;
        });

        return isAllChecked;
    }

    function clickOnJobTitle(e) {
        var $eTarget = $(e.target);
        const isJobTitle = $eTarget.is(".js-join-jobTitle");
        if (isJobTitle && $eTarget.is(':visible')) {
            if ($eTarget.val() !== '') $eTarget.removeClass('select-error');
            changeInputErrorMsg($eTarget, $eTarget.val() === '' ? $eTarget.attr('data-empty-msg') : "");
            return;
        }
    }

    function keyupJoinInput(e) {
        if (KeyCheck.isAvailable(e)) return;
        var $eTarget = $(e.target);
        var isEmailInput = $eTarget.is(".js-join-email");
        var isPasswordInput = $eTarget.is(".js-join-password");
        var isPasswordInput2 = $eTarget.is(".js-join-password2");
        var isTeamNameInput = $eTarget.is(".js-team-name");
        const isUserNameInput = $eTarget.is(".js-name-input");
        var $isErrorStatus = $eTarget.hasClass("input-error");
        var isSector = $eTarget.is(".js-sector-input");

        if (!isTeamNameInput && !isUserNameInput) removeBlank($eTarget); //팀이름 제외 공백제거

        var checkJson = Validation.checkInput($eTarget);
        var isValidate = (Object.keys(checkJson).length === 0) || checkJson.errorCode === "empty";

        if (isEmailInput && (KeyCheck.isUpperCase(e) || Validation.checkContainUpperCase($eTarget.val()))) {
            changeInputErrorMsg($eTarget, i18next.t(common.capitalOnly));
            $eTarget.val($eTarget.val().toLowerCase());
            return;
        }

        //이메일 에러모드 또는 글자수 제한을 넘기 전까지 키업체크안함
        if (isEmailInput && !$isErrorStatus && !(checkJson.errorCode === "over")) return;

        if (isSector) {
            changeInputErrorMsg($eTarget, $eTarget.val().length > 30 ? i18next.t(main.placeHolder.lengthLimit, {count: 30}) : '');
            return;
        }

        changeInputErrorMsg($eTarget, isValidate ? "" : checkJson.errorMessage);

        if (isPasswordInput || isPasswordInput2) {
            var isExistPassword = "" !== $eTarget.val();
            $eTarget.parent().find(".js-view-button").css("display", isExistPassword ? "block" : "none");
        } else {
            //pass
        }

        //비밀번호 키업시 비밀번호 확인영역 체크
        var $joinPassword2 = $eTarget.findUp("#userStep").find(".js-join-password2");
        if (isPasswordInput && "" !== $joinPassword2.val()) {
            checkJson = Validation.checkInput($joinPassword2);
            var isSamePassword = (Object.keys(checkJson).length > 0) && checkJson.errorCode === "un-valid";
            changeInputErrorMsg($joinPassword2, isSamePassword ? checkJson.errorMessage : "");
        }
    }

    function removeBlank($inputEl) {
        var inputVal = $inputEl.val().replace(/ /gi, '');
        $inputEl.val(inputVal);
        if (inputVal === 0) changeInputErrorMsg($inputEl, "");
    }

    function focusoutJoinInput(e) {
        var $eTarget = $(e.target);
        if ($eTarget.val().length === 0) return;

        const checkJson = Validation.checkInput($eTarget)
        const isValid = Object.keys(checkJson).length === 0 || checkJson.errorCode === 'empty'
        changeInputErrorMsg($eTarget, isValid ? '' : checkJson.errorMessage)

        if ($eTarget.is(".js-join-email")) {
            if (Object.keys(checkJson).length > 0) return;
            if (Validation.checkContainUpperCase($eTarget.val())) {
                changeInputErrorMsg($eTarget, i18next.t(common.capitalOnly));
                $eTarget.val($eTarget.val().toLowerCase());
                return;
            }
            Ajax.executeApi(RestApi.GET.COLABO_USER_DUPLICATE_R001, {
                USER_ID: $.trim($eTarget.val())
            }, function (dat) {
                var errorCode = Often.null2Void(dat['ERR_CD']);
                const defaultErrMsg =  i18next.t(common.occupy, {val: $t(dictionary.email)});
                //다국어 코드 나오면 다국어 작업

                const companyRegisterErrorMsg = i18next.t(login.accountAlreadyJoin);
                const errMsg = errorCode === '6000' ? companyRegisterErrorMsg : errorCode !== '0000' ? defaultErrMsg :  "";

                changeInputErrorMsg($eTarget, errMsg);
            })
        }
    }

    function changeInputErrorMsg($inputEl, errMsg) {
        var isLabelParent = $inputEl.parent("label").length > 0;
        var $parent = isLabelParent ? $inputEl.parent("label") : $inputEl.parent("div");
        var $errorText;
        if ($inputEl.is("#joinTeamUrl") || $inputEl.is("#joinUserJobTitle") || $inputEl.is("#joinGuestJobTitle")) {
            $errorText = $parent.siblings(".error-text");
        } else {
            $errorText = $parent.find(".error-text");
        }
        if (errMsg && errMsg.length > 0) {
            $inputEl.addClass("input-error");
            $errorText.css("display", "block");
        } else {
            $inputEl.removeClass("input-error");
            $errorText.css("display", "none");
        }
        $errorText.text(errMsg);
    }

    // 서비스 이용기관 개인정보처리 방침
    function clickConfirmCheck(e) {
        var $eTarget = $(e.target);
        var $errorText = $eTarget.findUp(".js-join-check").find(".js-error-text");
        $eTarget.toggleClass('checked');
        $errorText.css("display", "none");
    }

    function clearPrevPageData($inputEl) {
        // 체크 지우기
        var $confirmCheck = $(".js-confirm-check");
        $confirmCheck.removeClass("checked");
        $confirmCheck.parent().find(".js-error-text").css("display", "none");
        // 전 페이지 input 값 비우기
        $.each($inputEl, function (i, input) {
            var $input = $(input);
            changeInputErrorMsg($input, "");
            $input.val("");
        })
    }

    function mousedownViewButton(e) {
        var $pwd = $(e.target).parent().find(".js-join-input");
        $pwd.attr('type', 'text');
    }

    function mouseupViewButton(e) {
        var $pwd = $(e.target).parent().find(".js-join-input");
        $pwd.attr('type', 'password');
    }

    // Note. 모바일 웹은 touch 동작이여서 분기 처리함
    function mousedownViewToggleButton(e) {
        var $button = $(e.target).closest(".js-view-button");
        var $pwd = $(e.target).parent().find(".js-join-input");
        if ($button.hasClass("on")) {
            $button.removeClass("on");
            $pwd.attr('type', 'password');
        } else {
            $button.addClass("on");
            $pwd.attr('type', 'text');
        }
    }

    function changeTeamSector(e) {
        var $eTarget = $(e.target);
        var $teamSectorInput = $eTarget.findUp(".js-sector-section").find(".js-sector-input");
        CommonJoin.changeInputErrorMsg($teamSectorInput, "");
        if ($eTarget.val() === 'etc') {
            $teamSectorInput.fadeIn(200);
        } else {
            $teamSectorInput.fadeOut(0);
            $teamSectorInput.val("");
        }
    }
    function isHopeUserSelectInTeamStep($teamStep = $("")) {
        if($teamStep.length === 0 || !$teamStep.is(":visible")) {
            return false;
        }

        const HopeUserSelector = requireModule("HopeUserSelector", { on : ["main"]})();
        const $hopeUserSelectorLayer = $teamStep.find("#joinTeamHopeUserCountSelector")
        if(HopeUserSelector?.isNoSelect($hopeUserSelectorLayer)) {
            HopeUserSelector?.changeInputErrorMsg($hopeUserSelectorLayer, i18next.t(common.select, {val: $t(common.estimatedNumberOfPeople)}));
            return true
        }
        return false;

    }
    // teamStep or flowUpgradeStep --> finalStep
    function moveFinalStepButton(e, callback = null, planCode = 'businessBasic') {
        let isStop;
        const $stepSection = $(e.target).findUp(".js-step-section");
        const $teamStep = $(e.target).findUp(".js-team-step");
        if (isInputsError($teamStep)) isStop = true;
        if (isJobTitleSelected($teamStep)) isStop = true;
        if (isHopeUserSelectInTeamStep($teamStep)) isStop = true;
        if (!isCheckSectors($stepSection)) isStop = true;
        if (!isCheckSectorsInUpgradeView($stepSection)) isStop = true;
        if (isStop) return;

        const isFlowUpgradeStep = $stepSection.find("#flowUpgradeStep").length > 0; // 플로우 계정 업그레이드
        const isKakaoUpgradeStep = $stepSection.find("#kakaoUpgradeStep").length > 0; // 카카오 계정 업그레이드
        const isJoinStep = !(isFlowUpgradeStep || isKakaoUpgradeStep);// 회원가입

        const passJson = isFlowUpgradeStep ? getFlowUpgradeInfo() : {
            ...getUserInfo("joinUser"),
            ...getTeamInfo(),
            ...getPartnerInfo(),
        };

        passJson.packetOption = Ajax.OPTION.PREVENT_EXECUTE;

        Ajax.executeApi(RestApi.POST.FLOW_SUB_DOM_C001, passJson, function (dat) {
            const errorCode = Often.null2Void(dat['ERR_CD'], '');
            const $teamUrl = $stepSection.find(".js-team-url");
            //NO_PROBLEM: '0000', EXISTS_URL: '1000', YOU_MANAGER: '3000',
            if ('3000' === errorCode) {
                CommonJoin.changeInputErrorMsg($teamUrl, i18next.t(main.alert.teamExist));
                return;
            } else if ('1000' === errorCode) {
                CommonJoin.changeInputErrorMsg($teamUrl, i18next.t(common.occupy, {val: 'URL'}));
                return;
            } else if ("7000" === errorCode) {
                CommonJoin.changeInputErrorMsg($teamUrl, i18next.t(exception.error.limitEmail));
                return;
            }
            if (window.isNewFinalStep && isJoinStep) {
                Loading.drawLoadingPop(true);
                CommonJoin.setGtmCollect(Often.isGlobal()? "signup5" : "signUp3")
                if(typeof window.growsumo !== "undefined" && !!window.growsumo?.data.partner_key) {
                    growsumo.data.customer_key = passJson.USER_ID;
                    growsumo.data.email = passJson.USER_ID;
                    growsumo.data.name = passJson.USER_ID;
                    growsumo.createSignup();
                }
                goLoginAfterJoin(passJson, () => {
                    CommonLogin.moveMainPage({desktopGuideYn: 'N'});
                });
                return;
            }
            callback?.();
            openFinalStep(passJson, {
                isFlowUpgradeStep: isFlowUpgradeStep,
                isKakaoUpgradeStep: isKakaoUpgradeStep,
                isJoinStep: isJoinStep
            }, planCode);
        })
    }

    function isInputsError($step) {
        var errMsg;
        var isError = false;
        var inputs = $step.find(".js-join-input").visible();
        $.each(inputs, function (i, input) {
            var $input = $(input);
            // 비어있는 input 있는지 확인
            if ($input.val().length === 0) {
                errMsg = $input.attr("data-empty-msg")
                isError = true;
                changeInputErrorMsg($input, errMsg);
            }

            if ($input.is(":password")) {
                var checkJson = Validation.checkInput($input);
                if (Object.keys(checkJson).length > 0) {
                    isError = true;
                    changeInputErrorMsg($input, checkJson.errorMessage);
                }
            }
            // 오류가 난 input 있는지 확인
            if ($input.hasClass("input-error")) isError = true;
        })
        return isError;
    }

    function isJobTitleSelected($step) {
        const $jobTitle = $step.find(".js-join-jobTitle").visible();
        if ($jobTitle.val() === '') {
            $jobTitle.addClass('select-error');
            changeInputErrorMsg($jobTitle, $jobTitle.attr("data-empty-msg"));
            return true;
        }
        return false;
    }

    function openFinalStep(passJson, stepJson, planCode) {
        let planName;
        if (Often.isGlobal()) {
            planName = LocalUtil.getLocal("IN_PAYMENT_CURRENT_PLAN_NAME") ?? i18next.t(common.pro);
        } else {
            planName = LocalUtil.getLocal("IN_PAYMENT_CURRENT_PLAN_NAME") ?? i18next.t(common.businessBasic);
        }

        const $teamStep = $("#teamStep");
        const $finalStep = $("#finalStep");
        const isReal = Often.isServerModeByHost("REAL") || Often.isServerModeByHost("REAL_TEST");
        const finalTitleText = i18next.t(common.planUpgradeComplete, {val: !!planCode ? planName : $t(dictionary[planCode])});
        const finalDesc = i18next.t('main:payment.complete.welcome', {val: $t(dictionary[planCode === "businessPro" ? "business" : planCode])});

        Often.setCookie("FLOW_LANG", Often.null2Void(Often.getCookie("FLOW_LANG"), window._CF_LANG));
        $finalStep.find("#finalTitle").text(finalTitleText);
        $finalStep.find("#finalDesc").text(finalDesc);
        $finalStep.find("#finalDesc2").text(i18next.t(main.alert.signupMaster, {
            userName: passJson.USER_NM,
            companyName: passJson.SUB_DOM_NM
        }));
        $finalStep.find("#finalTeamUrl").text(passJson.SUB_DOM);
        $finalStep.find("#finalTeamUrl2").text((!isReal ? FLOW_URL.TEST : FLOW_URL.REAL) + "/corpsignup.act");
        $finalStep.find("#copyUrlButton").off("click").on("click", copyTeamUrl);
        $("#closeUpgradePageBtn").css("display", "none");
        $finalStep.find("#startButton").off("click").on("click", function () {
            Loading.drawLoadingPop(stepJson.isJoinStep);
            //서비스 업그레이드 도중 '다른계정으로 가입하기' 에서 진행될때 isKakaoUpgradeStep 인식하는 문제 - 꼬일때로 꼬임
            if (stepJson.isJoinStep || stepJson.isKakaoUpgradeStep) {
                setGtmCollect("signUp3");
                // 회원가입, 업그레이드에서 회원가입, 카카오계정 업그레이드 -> 로그인
                goLoginAfterJoin(passJson, () => {
                    CommonLogin.moveMainPage({desktopGuideYn: 'N'});
                });
            } else if (stepJson.isFlowUpgradeStep) {
                // 플로우 계정 연동 업그레이드 -> window.reload
                setGtmCollect("upgrade");
                window.location.reload();

            }
        });
        if (stepJson.isJoinStep || stepJson.isKakaoUpgradeStep) {
            $teamStep.css("display", "none");
            setGtmCollect("signUp2");
        } else if (stepJson.isFlowUpgradeStep) {
            $("#flowUpgradeStep,#allMainContent").css("display", "none");
            $('body').css("overflow-y", "auto");
            setGtmCollect("upgrade");
        }
        $finalStep.fadeIn(200);
    }

    function setGtmCollect(eventType) {
        const json = {};
        if (eventType === "signUp3" || eventType === "upgrade" || eventType === "signup4") {
            json["userId"] = $("#joinUserEmail").val() || _USER_ID;
            json["company"] = $("#joinTeamName").val() || $("#upgradeTeamName").val();
            json["joinDate"] = Time.currentTime();
            const queryStringJson = Often.getLocationQueryParamJson();
            json["touchPoint"] = Often.null2Void(queryStringJson["utm_source"], "");
        }
        json["event"] = eventType;
        GoogleTagManager.collect(json);
    }

    function copyTeamUrl() {
        var userName = $("#joinUserName").val() || _USER_NM;
        var teamName = $("#finalTeamName").text();
        var copyUrl = $("#teamServiceUrl").text();
        if (Often.isMobile() || Often.isTablet()) {
            var corpUrl = copyUrl + "\/corpsignup.act";
            navigator.share({
                title: i18next.t(main.alert.joinTeam, {val: teamName}),
                text: i18next.t(main.alert.welcomeTeam, {userName: userName, teamName: teamName, copyUrl: copyUrl})
            }).then(() => {
            })
                .catch(console.error);
        } else {
            var invitedText = i18next.t(main.alert.welcomeTeam, {
                userName: userName,
                teamName: teamName,
                copyUrl: copyUrl
            });
            const convertedInvitedText = invitedText.replace(/(&#x2F;)/g, '/')
            Often.copyUrl(convertedInvitedText);
        }
    }

    function goLoginAfterJoin(userInfo, callback) {
        var isElectron = ElectronApi.Comm.isElectron()
        CommonLogin.goLogin($.extend({}, userInfo, {
            "ID_GB": SignCode.TYPE.NORMAL,
            "ENCRYPT_YN": SignCode.ENCRYPT.SERVER_TIME_CHECK,
            "OBJ_CNTS_NM": (isElectron ? "desktop" : ""),
            "DESKTOP_GUIDE_YN": "Y",
        }), callback)
    }

    function registerSubDomain(e) {
        moveSecondStepButton(e, function () {
            var userInfo = CommonJoin.getUserInfo("joinUser");
            userInfo.packetOption = Ajax.OPTION.PREVENT_EXECUTE;
            Mutil.openLoadingPop($("body"))
            Ajax.executeApi(RestApi.POST.COLABO2_REGISTER_C001, $.extend({}, userInfo, {
                SUB_DOM: SUB_DOM,
            }), function (dat) {
                var errorCode = Often.null2Void(dat['ERR_CD'], '');
                if ("0000" !== errorCode) {
                    if ("5000" === errorCode) {
                        changeInputErrorMsg($("#joinUserEmail"), i18next.t(common.occupy, {val: $t(dictionary.email)}));
                    } else if ("7000" === errorCode) {
                        changeInputErrorMsg($("#joinUserEmail"), i18next.t(exception.error.limitEmail));
                    }
                    return;
                }
                const isPassCheck2fa = !Often.isEmpty(window.SUB_DOM) && "Y" === Often.null2Void(dat.JNNG_ATHZ_YN, "N");
                goLoginAfterJoin({
                    ...userInfo ,
                    PASS_CHECK_2FA_YN : isPassCheck2fa ? "Y" : " N"
                });
            })
        })
    }
    function isCheckSectorsInUpgradeView($stepSection) {
        const NO_SELECT = "default";
        const $sectorSection = $stepSection.find(".js-sector-section");
        const $teamSector = $sectorSection.find("#upgradeTeamSector");
        // 회사 업종 선택 안했을 경우
        let isCheck = true;
        if(NO_SELECT === $teamSector.val()) {
            CommonJoin.changeInputErrorMsg($teamSector, i18next.t(common.select, {val: $t(dictionary.industry)}));
            isCheck =  false
        }
        // 회사 업종 - 기타를 선택했을 때 입력을 안했읅 경우
        if ( "etc" === $teamSector.val()) {
            const $sectorInput = $sectorSection.find(".js-sector-input")
            if ($sectorInput.val().length === 0) {
                CommonJoin.changeInputErrorMsg($teamSector , i18next.t(common.input, {val: $t(dictionary.industry)}));
                isCheck =  false
            }
        }

        // 예상 인원 수를 선택하지 않은 경우
        const $hopeUserSelectorLayer=  $stepSection.find("#updateHopeUserCountSelectorLi");
        const HopeUserSelector = requireModule("HopeUserSelector", { on : ["main"]})();
        if(HopeUserSelector?.isNoSelect($hopeUserSelectorLayer)) {
            HopeUserSelector?.changeInputErrorMsg($hopeUserSelectorLayer, i18next.t(common.select, {val: $t(common.estimatedNumberOfPeople)}));
            isCheck =  false
        }

        return isCheck;

    }
    function isCheckSectors($stepSection) {
        var $sectorSection = $stepSection.find(".js-sector-section");
        var $select = $sectorSection.find("select");
        var selectVal = $select.val();
        var $sectorInput = $sectorSection.find(".js-sector-input")
        var isCheck = (selectVal !== "default");
        if (!isCheck) CommonJoin.changeInputErrorMsg($select.parent(), i18next.t(common.select, {val: $t(dictionary.industry)}));
        if (selectVal === "etc") {
            if ($sectorInput.val().length === 0) {
                isCheck = false;
                CommonJoin.changeInputErrorMsg($select.parent(), i18next.t(common.input, {val: $t(dictionary.industry)}));
            }
        }
        return isCheck;
    }

    function getUserInfo(page) {
        return {
            USER_NM: $.trim($("#" + page + "Name").val()),
            USER_ID: $.trim($("#" + page + "Email").val()),
            RESAILER: $.trim($("#" + page + "RecommendId").val()),
            CELLPHONE_NUM: $.trim($("#" + page + "PhoneNum").val()),
            PWD: page === "joinGuest" ? $("#joinGuestPassword").val() : $("#password").val(),
            MARKETING_YN: $.trim($("#" + page + "MarketingAgreementCheck").is(":checked")) === 'true' ? 'Y' : 'N',
            RSPT_NM: $.trim($("#" + page + "JobTitle").val()),
        }
    }

    function getTeamInfo() {
        var pathCd;
        var $teamStep = $("#teamStep");
        var teamSectorVal = $teamStep.find("#joinTeamSector").val();
        var planId = LocalUtil.getLocal("JOIN_PLAN_ID") || LocalUtil.getLocal("IN_PAYMENT_SELECTED_PLAN");
        LocalUtil.removeLocal("JOIN_PLAN_ID");

        if (teamSectorVal !== 'etc') pathCd = teamSectorVal;
        else pathCd = $teamStep.find("#joinTeamSectorInput").val();
        const HopeUserSelector = requireModule("HopeUserSelector", { on : ["main"]})();
        return {
            SUB_DOM_NM: $.trim($teamStep.find("#joinTeamName").val()),
            SUB_DOM: $.trim($teamStep.find("#joinTeamUrl").val()),
            PATH_CD: $.trim(pathCd),
            PLAN_ID: planId || getDefaultPlanId(),
            HOPE_USER_COUNT: HopeUserSelector.getSelectorValue($teamStep.find("#joinTeamHopeUserCountSelector"))
        }
    }

    function getFlowUpgradeInfo() {
        var $flowUpgradeStep = $("#flowUpgradeStep");
        const HopeUserSelector = requireModule("HopeUserSelector", { on : ["main"]})();
        return {
            SUB_DOM: $flowUpgradeStep.find("#upgradeTeamUrl").val(),
            SUB_DOM_NM: $flowUpgradeStep.find("#upgradeTeamName").val(),
            USER_ID: _USER_ID,
            USER_NM: _USER_NM,
            PATH_CD: $flowUpgradeStep.find("#upgradeTeamSector").val(),
            PLAN_ID: PaymentStore.getSelectedPlan() || LocalUtil.getLocal("IN_PAYMENT_SELECTED_PLAN"),
            HOPE_USER_COUNT : HopeUserSelector.getSelectorValue($flowUpgradeStep.find("#updateHopeUserCountSelectorLi")),
        }
    }

    function getPartnerInfo() {
        const puid = Mutil.getCookie("PARTNER_UID") || null;
        Mutil.deleteCookie("PARTNER_UID");
        return (puid) ? {PARTNER_KEY: puid} : {};

        /*
        if (!window.growsumo?.data.partner_key) return {};
        return {
            PARTNER_KEY: window.growsumo?.data.partner_key,
        }
        */
    }
})()
